<template>
	<div>
		<SentimentDayTiming title="周期择时" subText="节点把控" modal="0"></SentimentDayTiming>
	</div>
</template>

<script>
		
	import SentimentDayTiming from 'components/sentiment/SentimentDayTiming.vue'
	
	export default {
		components: {
			SentimentDayTiming

		},
		data() {
			return {
				
			}
		}
	}
</script>

<style scoped>

</style>
